module.exports = "/assets/3uhXXT6vHI.png";